import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';
import { KeycloakInitStateService } from 'src/app/core/services/keycloak-init-state.service';

/**
 * Avviso mostrato quando il ritorno da Keycloak non ha aperto una sessione.
 * Sta nel layout, sopra il contenuto, perché l'utente può atterrare su una
 * qualsiasi pagina pubblica: la rotta protetta che voleva raggiungere lo ha
 * rimbalzato lì (vedi i guard) e senza spiegazione sembrerebbe un errore muto.
 */
@Component({
  selector: 'app-auth-notice',
  templateUrl: './auth-notice.component.html',
  styleUrls: ['./auth-notice.component.scss'],
  standalone: false,
})
export class AuthNoticeComponent {
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);
  readonly initState = inject(KeycloakInitStateService);

  /** Tentativo esplicito: `login()` azzera lo stato di fallimento. */
  async retry(): Promise<void> {
    await this.authService.login(this.router.url);
  }

  dismiss(): void {
    this.initState.dismissNotice();
  }
}
